import { Filter } from "../../models/filter/filter.model";
import { Property } from "../../models/property/property.model";

export namespace Properties {
	export class FetchAll {
		static readonly type = "[Property] Fetch all";
	}

	export class FecthProperty {
		static readonly type = "[Property] Fetch Property";
		constructor(public propertyId: number) {}
	}

	export class Add {
		static readonly type = "[Property] Add ";
		constructor(public property: Property | FormData) {}
	}

	export class Update {
		static readonly type = "[Property] Update";
		constructor(public propertyId: number, public property: Property | FormData) {}
	}

	export class SetFilter {
		static readonly type = "[Property] Set Filter";
		constructor(public filter: Filter) {}
	}

	export class Delete {
		static readonly type = "[Property] Delete Property";
		constructor(public propertyId: number) {}
	}
}
